import { render, staticRenderFns } from "./productDetailsImport.vue?vue&type=template&id=85df5bd8&scoped=true&"
import script from "./productDetailsImport.vue?vue&type=script&lang=js&"
export * from "./productDetailsImport.vue?vue&type=script&lang=js&"
import style0 from "./productDetailsImport.vue?vue&type=style&index=0&id=85df5bd8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df5bd8",
  null
  
)

export default component.exports